
export default () => {
  return {
    visibleClass: '',
    animationClasses: '',
    animationClassesCaption: '',
    animationClassesBar: '',
    activeProject: {
      title: '',
      customer: '',
      image: {
        src: '',
      },
      excerpt: '',
      categories: [],
      strategies: [],
      link: '',
    },
    filters: {
      category: '',
    },
    revealProject(project) {
      this.animationClassesBar = 'scale-0'
      setTimeout(() => {
        this.animationClasses = '-rotate-90 opacity-10 -translate-y-125%'
        this.animationClassesCaption = '-rotate-180 md:rotate-180 opacity-5 -translate-y-150% md:translate-y-150%'
        setTimeout(() => {
          const nextProject = typeof project === 'string' ? JSON.parse(project) : project
          this.activeProject = nextProject && Object.keys(nextProject).length > 0 ? nextProject : this.activeProject
          this.animationClasses = ''
          this.animationClassesCaption = ''
          setTimeout(() => {
            this.animationClassesBar = 'scale-1'
          }, 400)
        }, 800)
      }, 200)
    },
    changeCategory(term) {
      this.filters.category = term ? term.term_id : ''
      // WP-QUERY ?
    },
  }
}
